'use strict';

module Patersons {

  export interface ChangeRequestScope extends ng.IScope {
    events: ChangeRequestViewCtrl;
    //accounts: Array<Account>;
    changeRequests: Array<ChangeRequest>;
    currentChangeRequest: ChangeRequest;
    currentIndex: number;
    originalData: any;
    originalDataKeys: string[];
    modifiedData: any;
    modifiedDataKeys: string[];
    isLoading: boolean;
    hasChangeRequests: boolean;
    submissionFailedVerifyPhoneNumber: boolean;
    isBusy: boolean;
    isError: boolean;
  }

  export class ChangeRequestViewCtrl extends ChangeRequestBaseCtrl {
    scope: Patersons.ChangeRequestScope;
    rootScope: ng.IRootScopeService;
    changeRequestService: Patersons.ChangeRequestService;
    tokenService: Patersons.TokenService;
    identityService: Patersons.IdentityService;
    modal: any;

    static $inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'changeRequestService', 'tokenService', 'navigationService','identityService'];

    constructor($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, changeRequestService, tokenService, navigationService, identityService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.rootScope = $rootScope;
      this.changeRequestService = changeRequestService;
      this.tokenService = tokenService;
      this.identityService = identityService;

      this.scope.events = this;
      this.scope.currentIndex = 0;

      this.scope.isBusy = false;

      this.modal = $uibModal;

      this.load();
    }

    load() {
      this.scope.isLoading = true;
      this.scope.hasChangeRequests = false;

      this.changeRequestService.getChangeRequestsForApproval()
        .then((result) => {
          this.scope.changeRequests = result;

          if (this.scope.changeRequests && this.scope.changeRequests.length > 0) {
            this.scope.hasChangeRequests = true;
          }
          else {
            return;
          }

          this.setCurrentChangeRequest(0);
        }, (error) => { // error handling
          this.scope.isError = true;
          this.scope.isLoading = false;
        }).finally(() => {
          this.scope.isLoading = false;
        });
    }

    goToPreviousChangeRequest() {
      this.scope.currentIndex -= 1;

      if (this.scope.currentIndex < 0) {
        this.scope.currentIndex = 0;;
      }

      this.setCurrentChangeRequest(this.scope.currentIndex);
    }

    goToNextChangeRequest() {
      this.scope.currentIndex += 1;

      if (this.scope.currentIndex >= this.scope.changeRequests.length) {
        this.scope.currentIndex = this.scope.changeRequests.length - 1;
      }

      this.setCurrentChangeRequest(this.scope.currentIndex);
    }

    approveChangeRequest() {
      this.scope.submissionFailedVerifyPhoneNumber = false;

      this.identityService.getIsPhoneNumberVerifyed().
      then((phone_number_verified: boolean) => {
        if (phone_number_verified !== true) {
          this.scope.submissionFailedVerifyPhoneNumber = true;
          return;
        }

        var modalPopup = this.modal.open({
          templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
          controller: ApproveChangeRequestCtrl,
          keyboard: false,
          backdrop: 'static',
          resolve: {
            changeRequestId: this.scope.currentChangeRequest.id
          }
        });

        modalPopup.result
          .then((result) => {
            if (result === true) {
              this.scope.currentChangeRequest.isApproved = true;
              this.setApprovalStatusDescription(this.scope.currentChangeRequest);
              this.rootScope.$emit('changeRequestActioned', null);
            }
          }, (error) => { // error handling
            this.scope.isError = true;
            this.scope.isLoading = false;
          });
      });

      /*if (this.tokenService.tokenManager.profile.phone_number_verified !== 'true') {
        this.scope.submissionFailedVerifyPhoneNumber = true;
        return;
      }

      var modalPopup = this.modal.open({
        templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
        controller: ApproveChangeRequestCtrl,
        keyboard: false,
        backdrop: 'static',
        resolve: {
          changeRequestId: this.scope.currentChangeRequest.id
        }
      });

      modalPopup.result
        .then((result) => {
          if (result === true) {
            this.scope.currentChangeRequest.isApproved = true;
            this.setApprovalStatusDescription(this.scope.currentChangeRequest);
            this.rootScope.$emit('changeRequestActioned', null);
          }
        }, (error) => { // error handling
          this.scope.isError = true;
          this.scope.isLoading = false;
        });*/
    }

    rejectChangeRequest() {
      this.scope.isBusy = true;
      this.scope.currentChangeRequest.isRejected = true;
      this.setApprovalStatusDescription(this.scope.currentChangeRequest);

      this.changeRequestService.rejectChangeRequest(this.scope.currentChangeRequest.id)
        .then((result) => {
          this.rootScope.$emit('changeRequestActioned', null);
        }, (error) => { // error handling
          this.scope.isError = true;
          this.scope.isLoading = false;
        })
        .finally(() => {
          this.scope.isBusy = false;
        });

    }

    setCurrentChangeRequest(index: number) {
      this.scope.submissionFailedVerifyPhoneNumber = false;

      this.scope.currentChangeRequest = this.scope.changeRequests[index];
      this.setChangeRequestTypeDescription(this.scope.currentChangeRequest);
      this.setApprovalStatusDescription(this.scope.currentChangeRequest);

      this.constructOriginalDataObject(this.scope.currentChangeRequest);
      this.constructModifiedDataObject(this.scope.currentChangeRequest);
    }

    constructOriginalDataObject(changeRequest: ChangeRequest) {
      this.scope.originalData = null;
      this.scope.originalDataKeys = null;

      if (changeRequest.originalData === null) {
        return;
      }

      this.scope.originalData = JSON.parse(changeRequest.originalData);
      this.scope.originalDataKeys = Object.keys(this.scope.originalData);
    }

    constructModifiedDataObject(changeRequest: ChangeRequest) {
      this.scope.modifiedData = null;
      this.scope.modifiedDataKeys = null;

      if (changeRequest.modifiedData === null) {
        return;
      }

      this.scope.modifiedData = JSON.parse(changeRequest.modifiedData);
      this.scope.modifiedDataKeys = Object.keys(this.scope.modifiedData);
    }

    setApprovalStatusDescription(changeRequest: ChangeRequest) {
      if (changeRequest.isApproved) {
        changeRequest.approvalStatusDescription = 'Approved';
      }
      else if (changeRequest.isRejected) {
        changeRequest.approvalStatusDescription = 'Rejected';
      }
      else {
        changeRequest.approvalStatusDescription = 'Pending';
      }
    }

    setChangeRequestTypeDescription(changeRequest: ChangeRequest) {
      switch (changeRequest.changeRequestType) {
        case 'AccoladeOptions':
          changeRequest.changeRequestTypeDescription = 'Accolade Options';
          break;
        case 'AddressDetails':
          changeRequest.changeRequestTypeDescription = 'Address Details';
          break;
        case 'RegistrationAddressDetails':
          changeRequest.changeRequestTypeDescription = 'Registration Address Details';
          break;
        case 'AccountEmailAddress':
          changeRequest.changeRequestTypeDescription = 'Account Email Address';
          break;
        case 'ContractNoteEmailAddress':
          changeRequest.changeRequestTypeDescription = 'Contract Note Email Address';
          break;
        case 'PhoneNumbers':
          changeRequest.changeRequestTypeDescription = 'Phone Numbers';
          break;
        case 'BankAccountDetails':
          changeRequest.changeRequestTypeDescription = 'Bank Account Details';
          break;
        case 'TaxFileNumber':
          changeRequest.changeRequestTypeDescription = 'Tax File Number';
          break;
        default:
          changeRequest.changeRequestTypeDescription = changeRequest.changeRequestType
      }
    }
  }
}
